import React, { useEffect, useState } from 'react'
import Header from '../../../common/header/Header'
import Loader from '../../../../loader/Loader'
import Footer from '../../../common/footer/Footer'
import User_Dashbaord_Common_Section from '../user_dashboard_common_section/User_Dashbaord_Common_Section'
import { Link, useNavigate } from 'react-router-dom'
import { Get_Wallet_Details, get_wallet_history } from '../../../../api/category_product/Category_Product'
import { User_Authentication } from '../../../../user_authentication/User_Authentication'
import { toast } from 'react-toastify'

const User_Dashbaord_wallet = () => {
    const navigate = useNavigate();

    const [is_loading, set_Is_Loading] = useState(false)
    const [get_wallet_details, set_Wallet_Details] = useState({})
    const [get_wallet_list, set_Wallet_List] = useState([])

    const [currentPage, setCurrentPage] = useState(1);
    const productsPerPage = 10;

    // Calculate total pages safely
    const totalPages = Math.ceil(get_wallet_list?.length / productsPerPage) || 1;

    // Calculate the products to display on the current page
    const startIndex = (currentPage - 1) * productsPerPage;
    const currentProduct = get_wallet_list?.slice(startIndex, startIndex + productsPerPage) || [];

    // Pagination controls
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrev = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const getPaginationItems = () => {
        const items = [];
        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) {
                items.push(i);
            }
        } else {
            if (currentPage <= 3) {
                items.push(1, 2, 3, 4, '...', totalPages);
            } else if (currentPage >= totalPages - 2) {
                items.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            } else {
                items.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
            }
        }
        return items;
    };

    useEffect(() => {
        const handle_Get_Wallet_Details = async () => {
            set_Is_Loading(true)
            try {
                const token = User_Authentication();
                if (!token) {
                    toast("User token not found")
                    set_Is_Loading(false)
                    throw new Error("User token not found");
                }
                const response = await Get_Wallet_Details({ Authorization: `Bearer ${token}` })
                if (response?.data?.status == "200") {
                    set_Wallet_Details(response?.data?.data)
                    set_Is_Loading(false)
                }
                else if (response?.response?.data?.status == "401") {
                    set_Is_Loading(false)
                    localStorage.removeItem("user_token");
                    localStorage.removeItem("user_is_active");
                    toast("Token Expired. Please Login Again.");
                    navigate("/user-login");

                    return;
                }
                else if (response?.response?.data?.status == "500") {
                    set_Is_Loading(false)
                }
            }
            catch (error) {
                set_Is_Loading(false)
            }
        }
        handle_Get_Wallet_Details();
    }, [])

    useEffect(() => {
        const handle_get_wallet_history = async () => {
            set_Is_Loading(true)
            try {
                const token = User_Authentication();
                if (!token) {
                    // toast("User token not found")
                    set_Is_Loading(false)
                    throw new Error("User token not found");
                }
                const response = await get_wallet_history({ Authorization: `Bearer ${token}` })
                if (response?.data?.status == "200") {
                    set_Wallet_List(response?.data?.data)
                    set_Is_Loading(false)
                }
                else if (response?.response?.data?.status == "500") {
                    set_Is_Loading(false)
                }
            }
            catch (error) {
                set_Is_Loading(false)
            }
        }
        handle_get_wallet_history();
    }, [])

    const formatDateTime = (isoString) => {
        const date = new Date(isoString);
        const dateOptions = {
            year: 'numeric',
            month: 'short',
            day: '2-digit'
        };
        const timeOptions = {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        };
        const formattedDate = new Intl.DateTimeFormat('en-US', dateOptions).format(date);
        const formattedTime = new Intl.DateTimeFormat('en-US', timeOptions).format(date);
        return `${formattedDate} | ${formattedTime}`;
    };


    return (
        <div>
            {/* <--------- Header section's ------------> */}
            <Header />
            {/* <----------- Dashboard Order list here -----------> */}
            {
                is_loading ? (
                    <Loader />
                ) : (

                    <div className="bg-[#f8f9fa] pt-20 lg:pt-8 py-8 px-4 sm:px-6 lg:px-8">
                        <div className="max-w-[1320px] mx-auto pb-5 w-full">
                            <div className="w-full bg-white rounded-2xl shadow-sm border border-gray-100 p-4 sm:p-6 lg:p-8">
                                <div className="w-full">
                                    <div className="my_account w-full flex space-x-2 md:space-x-10">
                                        <User_Dashbaord_Common_Section />
                                        <div className="flex-1 min-w-0">
                                            <div className="item-body w-full">
                                                <div className="welcome-msg w-full mb-4">
                                                    <h1 className="font-bold text-2xl text-gray-800 tracking-tight">Wallet</h1>
                                                </div>

                                                <div className="w-full flex flex-col sm:flex-row justify-between items-stretch sm:items-center gap-4 bg-gradient-to-br from-[#9F2225] to-[#c92f33] rounded-2xl p-5 md:p-6 shadow-sm mb-6 mt-3">
                                                    <div className="flex items-center gap-4">
                                                        <div className="w-12 h-12 rounded-xl bg-white/20 text-white backdrop-blur-md flex justify-center items-center flex-shrink-0">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-wallet2" viewBox="0 0 16 16">
                                                                <path d="M12.136.326A1.5 1.5 0 0 1 14 1.78V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9a1.5 1.5 0 0 1 1.43-1.493L12.136.326zM5.562 3H13V1.78a.5.5 0 0 0-.621-.484zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z" />
                                                            </svg>
                                                        </div>
                                                        <div>
                                                            <p className="text-xs text-red-100 font-medium uppercase tracking-wider">Available Balance</p>
                                                            <span className="text-2xl md:text-3xl font-extrabold text-white mt-0.5 block">₹{get_wallet_details?.total_amount}</span>
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center">
                                                        <Link to="/user-wallet-recharge" className="w-full sm:w-auto text-center justify-center inline-flex items-center gap-2 px-5 py-2.5 bg-white hover:bg-red-50 text-[#9F2225] text-sm font-bold rounded-xl shadow-sm hover:shadow transition-all duration-200">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus-circle-fill" viewBox="0 0 16 16">
                                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3z" />
                                                            </svg>
                                                            Recharge Wallet
                                                        </Link>
                                                    </div>
                                                </div>

                                                <div className="mt-8">
                                                    <h2 className="text-lg font-semibold text-gray-800 pb-4">Transaction History</h2>
                                                    <div className="overflow-x-auto w-full border border-gray-100 rounded-2xl shadow-sm">
                                                        <table className="w-full text-left border-collapse min-w-[700px]">
                                                            <thead>
                                                                <tr className="bg-gray-50/75 border-b border-gray-100">
                                                                    <th className="py-4 px-6 text-xs font-semibold text-gray-500 uppercase tracking-wider">Tran. ID</th>
                                                                    <th className="py-4 px-6 text-xs font-semibold text-gray-500 uppercase tracking-wider">Name/Place</th>
                                                                    <th className="py-4 px-6 text-xs font-semibold text-gray-500 uppercase tracking-wider">Date & Time</th>
                                                                    <th className="py-4 px-6 text-xs font-semibold text-gray-500 uppercase tracking-wider">Amount</th>
                                                                    <th className="py-4 px-6 text-xs font-semibold text-gray-500 uppercase tracking-wider">Payment Method</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody className="divide-y divide-gray-100">
                                                                {currentProduct?.length > 0 ? (
                                                                    currentProduct?.map((get_wallet_result, index) => {
                                                                        const isCredit = get_wallet_result?.transaction_type === "CR";
                                                                        return (
                                                                            <tr key={index} className="hover:bg-gray-50/50 transition-colors">
                                                                                <td className="py-4 px-6 text-sm text-gray-600 font-medium">{get_wallet_result?.transuction_id || "N/A"}</td>
                                                                                <td className="py-4 px-6 text-sm text-gray-800 font-semibold">{get_wallet_result?.place || "N/A"}</td>
                                                                                <td className="py-4 px-6 text-sm text-gray-500">{formatDateTime(get_wallet_result?.created_at)}</td>
                                                                                <td className="py-4 px-6 text-sm">
                                                                                    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold ${isCredit
                                                                                        ? "text-emerald-700 bg-emerald-50"
                                                                                        : "text-rose-700 bg-rose-50"
                                                                                        }`}>
                                                                                        {isCredit ? "+" : "-"}₹{get_wallet_result?.req_amount}
                                                                                    </span>
                                                                                </td>
                                                                                <td className="py-4 px-6 text-sm text-gray-600">
                                                                                    <span className="inline-flex items-center gap-1.5">
                                                                                        <span className="w-1.5 h-1.5 rounded-full bg-gray-400"></span>
                                                                                        Wallet
                                                                                    </span>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="5" className="py-8 text-center text-gray-400 text-sm">
                                                                            <div className="flex flex-col items-center justify-center gap-2">
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" className="bi bi-wallet2 text-gray-300" viewBox="0 0 16 16">
                                                                                    <path d="M12.136.326A1.5 1.5 0 0 1 14 1.78V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9a1.5 1.5 0 0 1 1.43-1.493L12.136.326zM5.562 3H13V1.78a.5.5 0 0 0-.621-.484zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z" />
                                                                                </svg>
                                                                                No Transactions Found
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                    {/* Pagination Start */}
                                                    <div className="flex flex-col sm:flex-row justify-between items-center gap-4 pt-6 border-t border-gray-100 mt-6">
                                                        <span className="text-sm text-gray-500 font-medium">
                                                            Showing {get_wallet_list?.length > 0 ? startIndex + 1 : 0}-{Math.min(startIndex + productsPerPage, get_wallet_list?.length)} of {get_wallet_list?.length} Transactions
                                                        </span>
                                                        <ul className="gi-pro-pagination-inner flex gap-1 list-none pl-0 m-0">
                                                            {currentPage > 1 && (
                                                                <li>
                                                                    <button
                                                                        onClick={handlePrev}
                                                                        className="next w-auto text-[#fff] bg-[#5caf90] bg-red-500 text-[14px] px-2 rounded"
                                                                    >
                                                                        Prev
                                                                    </button>
                                                                </li>
                                                            )}
                                                            {getPaginationItems().map((page, index) => {
                                                                if (page === '...') {
                                                                    return (
                                                                        <li key={`ellipsis-${index}`} className="inline-block float-left">
                                                                            <span className="transition-all duration-[0.3s] ease-in-out text-[#777] text-[14px]">
                                                                                ...
                                                                            </span>
                                                                        </li>
                                                                    );
                                                                }
                                                                return (
                                                                    <li key={page} className="inline-block float-left">
                                                                        <button
                                                                            onClick={() => handlePageChange(page)}
                                                                            className={`transition-all duration-[0.3s] ease-in-out font-light 
                                                                                text-[#777] bg-[#eee] px-2
                                                                                text-[14px] rounded
                                                                                ${currentPage === page ? 'active bg-red-500 text-white' : 'bg-gray-300 text-black'}`}
                                                                        >
                                                                            {page}
                                                                        </button>
                                                                    </li>
                                                                );
                                                            })}
                                                            {currentPage < totalPages && (
                                                                <li>
                                                                    <button
                                                                        onClick={handleNext}
                                                                        className="next w-auto text-[#fff] px-2 bg-[#5caf90] text-[14px] rounded"
                                                                    >
                                                                        Next
                                                                    </button>
                                                                </li>
                                                            )}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
            {/* <-------- footer section's --------------> */}
            <Footer />
        </div>
    )
}

export default User_Dashbaord_wallet